/**
 * Styles for PrivacyLegalDocumentModal (scrollable sheet inside BaseModal).
 */

import { StyleSheet, Platform } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'
import type { MenuSheetLayout } from '../../../src/layout/helpers/menuSheetLayout.helper'

export const getPrivacyLegalDocumentModalStyles = (
  theme: Theme,
  layout: MenuSheetLayout
) =>
  StyleSheet.create({
    modalOuter: {
      width: '100%',
      maxWidth: 548,
      maxHeight: layout.outerMaxHeightPx,
      paddingHorizontal: 16,
      paddingVertical: 20,
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 1,
      ...(Platform.OS === 'web' && {
        minHeight: 0,
      }),
    },
    sheet: {
      width: '100%',
      maxWidth: 528,
      maxHeight: layout.sheetMaxHeightPx,
      minHeight: 0,
      borderRadius: 22,
      backgroundColor: theme.background.card,
      overflow: 'hidden',
      ...(Platform.OS === 'web'
        ? {
            boxShadow: '0 16px 48px rgba(0,0,0,0.14)',
          }
        : {
            shadowColor: theme.shadow ?? '#000',
            shadowOffset: { width: 0, height: 10 },
            shadowOpacity: 0.12,
            shadowRadius: 20,
            elevation: 14,
          }),
    },
    scroll: {
      maxHeight: layout.sheetMaxHeightPx,
      minHeight: 0,
    },
    scrollContent: {
      paddingBottom: 28,
      paddingHorizontal: 20,
      paddingTop: 48,
    },
    closeButton: {
      position: 'absolute',
      top: 8,
      right: 8,
      zIndex: 10,
      padding: 10,
      borderRadius: 999,
    },
    closeButtonPressed: {
      opacity: 0.65,
    },
    closeButtonHover: {
      opacity: 0.88,
    },
    title: {
      fontSize: 21,
      fontWeight: '700',
      color: theme.gray[900],
      textAlign: 'center',
      letterSpacing: -0.4,
      marginBottom: 8,
      paddingHorizontal: 8,
    },
    versionLine: {
      fontSize: 13,
      color: theme.gray[600],
      textAlign: 'center',
      marginBottom: 20,
      paddingHorizontal: 8,
    },
    section: {
      marginBottom: 22,
      paddingBottom: 22,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: theme.gray[200],
    },
    sectionLast: {
      marginBottom: 0,
      paddingBottom: 0,
      borderBottomWidth: 0,
    },
    sectionTitle: {
      fontSize: 16,
      fontWeight: '600',
      color: theme.gray[800],
      marginBottom: 10,
      letterSpacing: -0.2,
    },
    paragraph: {
      fontSize: 15,
      lineHeight: 22,
      color: theme.gray[600],
      marginBottom: 10,
    },
    paragraphLast: {
      marginBottom: 0,
    },
  })
